export default __webpack_public_path__ + "static/media/Turtlr-gameplay-screenshot-900px-600px.jpg.bd5c27ca.webp";